<template>
  <single-panel-page class="login-with-passcode-page">
    <div class="alert-default">
      <p>Please fill in a passcode</p>
    </div>

    <div v-show="hasErrors" class="alert alert-danger alert-nobg text-left">
      Wrong passcode
    </div>

    <form>
      <input
        v-model="passcode"
        class="form-control passcode-field"
        autofocus
        @keydown.enter="submit()"
      />

      <br />

      <button
        class="btn btn-primary"
        :class="{ 'animated pulse': clicked }"
        :disabled="inProgress"
        type="submit"
        @click="submit()"
      >
        <loader v-show="inProgress" class="loader-xs" />
        Submit
      </button>
    </form>

    <div slot="bottom">
      <span class="splash-box-footer hidden">
        <a href="">I do not have a passcode</a>
      </span>
    </div>
  </single-panel-page>
</template>

<script>
import Auth from '@/services/Auth'
import { delayed, sleep } from '@/utils'
import { getNewAppUrl } from '@/utils/urls'

export default {
  data: function () {
    return {
      passcode: '',
      inProgress: false,
      clicked: false,
      errors: { detail: [] },
    }
  },
  computed: {
    hasErrors() {
      return this.errors.detail.length > 0
    },
  },
  async created() {
    const self = this
    const providedPasscode = self.$route.query.passcode || ''
    let count = 0
    await sleep(250)
    const intervalId = setInterval(function () {
      if (self.passcode === providedPasscode) {
        clearInterval(intervalId) // deregisters interval
        self.submit()
      } else {
        count += 1
        self.passcode = providedPasscode.substring(0, count)
      }
    }, 50)
  },
  methods: {
    async submit() {
      const self = this
      self.clicked = true
      self.inProgress = true

      const showRoomId = self.$route.query.showroom_id
      const request = Auth.useMagicLink(
        self.$route.query.user_id,
        self.passcode,
      )
      const sleepPromise = sleep(1000)
      try {
        const response = await delayed(request, 1000)
        const userFetchRequest = self.$store.dispatch('user/fetch')
        await sleepPromise
        await userFetchRequest
        if (showRoomId) {
          window.location = getNewAppUrl(`/dashboard/showrooms/${showRoomId}`)
        } else {
          self.$store.dispatch('user/goToDefaultPage')
        }
      } catch (error) {
        console.log(
          ' => errors while trying to obtain auth token with passcode',
          error,
        )
      } finally {
        self.inProgress = false
      }
    },
  },
}
</script>

<style lang="scss">
.login-with-passcode-page {
  .passcode-field {
    text-transform: uppercase;
    font-size: 22px;
    text-align: center;
  }
}
</style>
